import { useLocation } from "@tanstack/react-router";

import { useBackendProps } from "@/react/providers/AppContext";

export const useSitePageMetadata = () => {
  const pathname = useLocation({ select: l => l.pathname });
  const { pages_app_page: sitePage } = useBackendProps();

  if (!sitePage) {
    return {
      isSitePageRoute: false,
      sitePageId: undefined,
      sitePageSlug: undefined,
    };
  }

  const path = pathname.toLowerCase();
  const slugPath = `/${sitePage.slug}`.toLowerCase();
  const isSitePageRoute = path === slugPath || path === `${slugPath}/`;

  return {
    isSitePageRoute,
    sitePageId: sitePage.id,
    sitePageSlug: sitePage.slug,
  };
};
